/**
 * Blog Sidebar front-end behaviour.
 *
 * THE NEWSLETTER FORM (T-079)
 *   Posts the address to the theme endpoint (`data-endpoint`, `inc/newsletter.php`), which hands
 *   it to the Newsletter plugin with double opt-in, and prints the outcome in the status line in
 *   the block's own words (`data-success|busy|invalid|error`). Only the success line claims
 *   anything, and it claims what happened: a confirmation email is on its way.
 *
 *   Without JavaScript the form posts to the plugin's own `?na=s` (its `action`), so it never
 *   silently does nothing.
 */

const STATES = {
	pending: 'success',
	invalid: 'invalid',
	busy: 'busy',
};

function initNewsletterForm( form ) {
	const status = form.parentElement.querySelector(
		'[data-ac-newsletter-status]'
	);
	const button = form.querySelector( 'button[type="submit"]' );

	const say = ( key ) => {
		if ( status ) {
			status.textContent = form.dataset[ key ] || form.dataset.error;
		}
	};

	form.addEventListener( 'submit', async ( event ) => {
		event.preventDefault();
		if ( ! form.dataset.endpoint || button.disabled ) {
			return;
		}

		button.disabled = true;
		if ( status ) {
			status.textContent = '';
		}

		try {
			const response = await fetch( form.dataset.endpoint, {
				method: 'POST',
				body: new FormData( form ),
				credentials: 'omit',
			} );
			const data = await response.json().catch( () => ( {} ) );
			const key = STATES[ data.status ] || 'error';
			say( key );
			if ( 'success' === key ) {
				form.reset();
			}
		} catch {
			say( 'error' );
		} finally {
			button.disabled = false;
		}
	} );
}

document.addEventListener( 'DOMContentLoaded', () => {
	document
		.querySelectorAll(
			'.wp-block-avoid-content-blog-sidebar form[data-ac-newsletter]'
		)
		.forEach( initNewsletterForm );
} );
